import React from "react";
import { BRAND } from "@/lib/avocado";

export function BrandLogo({ size = 40, withText = true, tone = "primary" }) {
  const textColor = tone === "light" ? "#FFFCF7" : "#171717";
  const subColor = tone === "light" ? "rgba(255,252,247,0.72)" : "#7A6D5F";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={BRAND.logoUrl}
        alt="Avocado Property"
        style={{ width: size, height: size, borderRadius: 12, objectFit: "cover", boxShadow: "0 3px 0 rgba(0,0,0,0.06)" }}
      />
      {withText && (
        <div className="flex flex-col leading-tight">
          <span className="font-display text-xl md:text-2xl" style={{ color: textColor, fontWeight: 700 }}>
            Avocado Property
          </span>
          <span className="uppercase-label" style={{ color: subColor, fontSize: "0.62rem" }}>
            Tom Gilbert's Referral Community
          </span>
        </div>
      )}
    </div>
  );
}
